module.exports = __webpack_public_path__ + "img/cityScape.38becb64.jpg";